<template> 
    <template v-if="popups.length > 0">
        <template v-for="(popup, index) in popups" :key="index">   
            <base-dialog :show="showpop[index].show" title="알려 드립니다" fixed @fixedclose="popClose(index,popup.id)" 
            :isMobile="isMobile"            
            >
            
                <div class="dialog_box" :class="{isMobile_popup:isMobile}">
                    <div class="item_title">
                        <h1>{{getTitle(popup.title)}}</h1>                   
                    </div>
                    <div class="content">   
                        <ckeditor :editor="editor" :disabled="editorDisabled" :model-value="popup.content"></ckeditor>          
                    </div>    
                  

                </div>
                <div class="quicklink">
                    <span @click="goPost(popup.document,popup.id)">해당 게시글로 바로가기</span>
                </div>
                <div class="footer">   
                   
                    <div class="checkform">
                        <base-checkbox :checkvalue="index"  @click="[icheck($event),sethideOneDay(popup.id)]"/>하루동안 팝업 띄우지 않기
                    </div>                    
                    <div class="btn_block">
                        <base-button-sm mode="orange" @click="popClose(index,popup.id)">확인</base-button-sm>    
                    </div>                        
                </div>
            </base-dialog>   
        </template> 
    </template> 
</template>
<script>
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { icheck } from '@/components/mixins/icheck.js';
import { cookie } from '@/components/mixins/cookie.js';
export default {
    name:'popupPost',
    props:[
        'isMobile'
    ],
    data(){
        return{
            popups:'',
            dialogs:'' ,
            showpop:[],           
            editor:DecoupledEditor,      
            editorDisabled: true,   
            hideOneDay:[],
           
        }
    },
    mixins:[ icheck, cookie],
    components:{

    },
    mounted() {
        this.getPopup();
    },
    methods:{
        goPost(document,id)
        {
            //모든팝업 닫기 
            this.showpop.forEach((_,i) => {
               // e는 element의 e 이고 i는 index의 i, a는 array의 a 입니다.    
                this.showpop[i] = false;                  
            });
            
            //this.$route.push();
            let menu = this.$store.getters['menu/getMenu'].find((menu)=>menu.title === document.menu).name            
            
            let main = 'main';
            if(this.isMobile)
            {
                main = 'm';   
            } 
            let routeurl = `/${main}/community/${menu}/${document.name}/view/${id}`
            this.$router.push(routeurl);
        },
        async getPopup(){
            //팝업 공지글 가져오기 
            const formData = {               
                popup:true,
                page:1
            }
            //alert(_user_id+"/"+ _search);
            try {
                const response = await this.$store.dispatch("posts/getSearchPosts", formData)
                //console.log('팝업가져오기',response);
                this.popups = response.data.reverse();   
                this.popups.forEach((e) => {
                    // e는 element의 e 이고 i는 index의 i, a는 array의 a 입니다.                  
                   
                    if(this.getCookie('popup_'+e.id)){
                        this.showpop.push({show:false, id:e.id});
                    }else{
                        this.showpop.push({show:true, id:e.id});    
                    }
                    
                    this.hideOneDay.push({hide:false, id:e.id});
                });  
                console.log('팝업 정보',this.showpop);             
            }catch(error){
                console.log(error.response);
            }
        },
        popClose(index,pop_id){
            //해당 팝업 하루동안 보지 않기 시 쿠키값 생성 해서 하이드 시킨다.           
            let hideOneDay = this.hideOneDay.find((pop)=>pop.id === pop_id);            
            if(hideOneDay.hide)
            {
                this.setCookie('popup_'+pop_id,'hide','1d')
            }            
            this.showpop[index] = false;
        },
        sethideOneDay(pop_id){
            let hideOneDay = this.hideOneDay.find((pop)=>pop.id === pop_id);
            hideOneDay.hide = !hideOneDay.hide;
        },
        getTitle(title)
        {               
            const lengthLimit =28;
            return title.substr(0, lengthLimit) + (title.length >lengthLimit?'...':'') ;
        },
       
    }
}
</script>
<style lang="scss" scoped>
.isMobile_popup{
    .item_title{
        h1{
            font-size:14px;
        } 
    }   
}
.item_title{
    h1{
        margin-top: 0 !important;
    }
}
.content{
    height: 400px;
    overflow-y: auto;    
}
.quicklink{
    padding:10px;
    text-align: center;
    font-weight: bold;  
    
    margin: 0 -20px;
    span{
        cursor: pointer;
    }
    
}
.footer{
    background:rgb(68, 68, 68);
    display:flex;
    justify-content: space-between;
    
    padding:20px;
    margin: 0 -20px -20px;
    .checkform{
        color:#fff;
        display: flex;
        align-items: center; 
        line-height:30px;      
    }
    .btn_block{
        width:100px;
    }
}
</style>